import * as shpwrite from "@mapbox/shp-write";
import { LAYER_CONFIG } from "../../../../app/GIS/constant";

export const gisHelperFunctions = {

    getESRILayersOrderedList() {
        // add the layers in bottom to top order.
        return [
            LAYER_CONFIG.REFERENCE.name,
            LAYER_CONFIG.GRID.name,
            LAYER_CONFIG.BLOCK.name,
            LAYER_CONFIG.BORDER.name,
            LAYER_CONFIG.FILLER.name,
            LAYER_CONFIG.PRESCRIPTION.name,
            LAYER_CONFIG.SKETCHVIEW.name
        ];
    },

    createAndDownloadShapeFile(geojson: any, fileName: string) {
        try {
            shpwrite.download(geojson, {
                folder: fileName,
                filename: fileName,
                types: {
                    point: "points",
                    polygon: fileName,
                    line: "lines"
                },
                compression: "STORE",
                outputType: "blob"
            });
            return true;

        } catch (error) {
            console.log("geoJson to shapFile error: ", error);
            return false;
        }
    },

    getUniqueId() {
        return (
            Math.random().toString(36).substring(2) +
            new Date().getTime().toString(36)
        );
    },

    getGridLabelAngle(theta: number) {
        if(theta < 0) {
            theta = 360 + theta;
        }
        const t = theta % 360;
        if(t <= 90) return 360 - t;
        if(t <= 180) return 180 - t;
        if(t <= 270) return 540 - t; // 360 - (t - 180);
        return 360 - t;
    },

    // getBlockLabelAngle(theta: number) {
    //     if(theta <= 90) return 90 - theta;
    //     else if(theta <= 180) return 360 - (theta - 90);
    //     else if(theta <= 270) return 270 - (theta - 180);
    //     else if(theta <= 360) return 180 - (theta - 270);
    //     return 90;
    // },

    getLineLength(xmin: number, ymin: number, xmax: number, ymax: number) {
        return Math.sqrt(Math.pow(ymax - ymin, 2) + Math.pow(xmax - xmin, 2));
    },

    getCoordinates(theta: number, x1: number, y1: number, gridLength: number, gridWidth: number, subPlot: number) {
        const rad = theta * Math.PI / 180;
        const cos = Math.cos(rad);
        const sin = Math.sin(rad);
        const width = gridWidth / subPlot;
        // Bottom left
        const bl = [x1, y1];
        // Top left
        const tl = [x1 + gridLength * cos, y1 + gridLength * sin];
        // Bottom right
        const br = [x1 + width * sin, y1 - width * cos];
        // Top right
        const tr = [tl[0] + width * sin, tl[1] - width * cos];
        const rings = [
            [bl, tl, tr, br, bl]
        ];
        return rings;
    },

    calculateSlope(xmin: number, ymin: number, xmax: number, ymax: number) {
        if (xmax === xmin && ymax === ymin) {
            throw new Error("Invalid points: both points are identical.");
        }

        let theta = Math.atan2(ymax - ymin, xmax - xmin) * (180 / Math.PI);  // atan2 returns angle with direction
        if (theta < 0) {
            theta += 360;
        }
        return theta;
    },
};
